<div class="flex_col" style="user-select: none; max-width: 100%; width: 100%">
  @if (labels?.length) {
    <div id="label_container" class="flex_row pl-3">
      @for (label of labels; track label) {
        <div class="label">
          <div class="color_circle" [style.background-color]="label.color"></div>
          <div style="margin: auto">
            {{ label.description }}
          </div>
        </div>
      }
    </div>
  }
  <div style="width: 100%; overflow-x: auto">
    <div style="width: fit-content; position: relative">
      <div
        style="
          width: fit-content;
          overflow-x: auto;
          position: relative;
          border: 1px solid lightgray;
          border-radius: 4px;
        "
        class="flex_col"
      >
        @if (options.length) {
          <mat-expansion-panel style="margin: 1px" [togglePosition]="'before'">
            <mat-expansion-panel-header>
              <mat-panel-title> Optionen </mat-panel-title>
              <div style="margin: auto 6px auto auto; padding: 4px 0" (click)="$event.stopPropagation()">
                <div class="flex_row" style="width: fit-content; flex-wrap: nowrap; font-weight: normal">
                  <div style="border-right: 1px solid black; margin-right: 4px">
                    <div
                      class="fast_filter"
                      [ngClass]="activeFilter === '' ? 'selected' : ''"
                      [style.color]="'black'"
                      [style.background-color]="'white'"
                      (click)="activeFilter = ''"
                    >
                      <div style="margin: auto 0; display: inline-flex; flex-direction: row">Alle</div>
                    </div>
                  </div>
                  @for (filter of filter; track filter) {
                    <div
                      class="fast_filter"
                      [ngClass]="activeFilter == filter ? 'selected' : ''"
                      [style.color]="'black'"
                      [style.background-color]="'white'"
                      (click)="activeFilter = filter"
                    >
                      <div style="margin: auto 0; display: inline-flex; flex-direction: row">
                        {{ filter }}
                        ({{ getFilterInstanceAmount(filter) }})
                      </div>
                    </div>
                  }
                </div>
              </div>
            </mat-expansion-panel-header>
            <table>
              <tbody>
                @for (option of options; track option) {
                  <tr style="border-top: 1px solid lightgray">
                    <td style="max-width: 160px; min-width: 160px; font-size: 0.9rem">
                      {{ option.title }}
                      @if (option.tooltip) {
                        <fa-icon [icon]="faInfoCircle" [tooltip]="option.tooltip"></fa-icon>
                      }
                    </td>
                    @for (bar of bars; track bar) {
                      @if (barIsShown(bar)) {
                        <td style="max-width: 48px; min-width: 48px; text-align: center">
                          <mat-checkbox
                            color="primary"
                            [(ngModel)]="bar.data.options[option.title]"
                            (change)="
                              changeOptionEvent.emit({
                                idx: bar.data.external_idx || bars.indexOf(bar),
                                option: option.title,
                                new_value: $event.checked,
                              })
                            "
                          ></mat-checkbox>
                        </td>
                      }
                    }
                  </tr>
                }
              </tbody>
            </table>
          </mat-expansion-panel>
        }
        <div class="bars-scroll-wrapper" #barsScrollWrapper>
          <div id="bars_container" class="flex_row" [style.height.px]="barsContainerHeightPx">
            <div id="bars_container_overlay"></div>
            <div
              style="
                position: relative;
                min-height: 100px;
                width: 50px;
                overflow-y: visible;
                border-right: 1px solid lightgray;
              "
              class="flex_col"
            >
              @for (unit_amount_step of unitAmountSteps; track unit_amount_step) {
                <div class="unit_amount_step" [style.bottom]="unit_amount_step.percentage + '%'">
                  <div>{{ unit_amount_step.description }}</div>
                  <div style="width: 14px; height: 0"></div>
                </div>
              }
            </div>
            <div class="flex_row" style="position: relative">
              @for (bar of bars; track bar) {
                @if (barIsShown(bar)) {
                  <div class="bar">
                    @if (bar.data.utilizationPercent != null) {
                      <div
                        class="utilization_badge"
                        [ngClass]="getUtilizationClass(bar.data.utilizationPercent)"
                        [style.bottom]="getBarTopPercent(bar) + '%'"
                      >
                        {{ bar.data.utilizationPercent }}%
                      </div>
                    }
                    @for (percentages of bar.percentages; track percentages) {
                      <div
                        class="sub_bar"
                        [tooltip]="$any(barTooltipTemplate)"
                        contentType="template"
                        [ngStyle]="{
                          bottom: percentages.from_percent + '%',
                          top: 100 - percentages.to_percent + '%',
                          'background-color':
                            (percentages.style || bar.data.style) === 'filled' ? percentages.color : 'transparent',
                        }"
                        [style.border]="'2px solid ' + percentages.color + '!important'"
                        (click)="
                          clickBarEvent.emit(bar.data.external_idx >= 0 ? bar.data.external_idx : bars.indexOf(bar))
                        "
                      >
                        @if (percentages.icon) {
                          <fa-icon class="bar_icon" [icon]="percentages.icon"></fa-icon>
                        }
                        <ng-template #barTooltipTemplate>
                          @if (percentages.tooltip.infos?.length) {
                            <div style="text-align: left">
                              <h6>Info</h6>
                              <ul>
                                @for (info of percentages.tooltip.infos; track info) {
                                  <li>
                                    {{ info }}
                                  </li>
                                }
                              </ul>
                            </div>
                          }
                          @if (percentages.tooltip.errors?.length) {
                            <div style="text-align: left">
                              <h6>Fehler</h6>
                              <ul>
                                @for (error of percentages.tooltip.errors; track error) {
                                  <li>
                                    {{ error }}
                                  </li>
                                }
                              </ul>
                            </div>
                          }
                        </ng-template>
                      </div>
                    }
                  </div>
                }
              }

              @for (deadline of deadlines; track deadline) {
                <div
                  class="deadline"
                  style="border-width: 2px !important; right: -50px !important; z-index: 15"
                  [style.bottom]="getDeadlinePercentage(deadline) + '%'"
                  [style.color]="deadline.color"
                  [style.border-color]="deadline.color + '!important'"
                >
                  @if (deadline.description) {
                    <div class="deadline_description">
                      {{ deadline.description }}
                    </div>
                  }
                </div>
              }

              @for (unit_amount_step of unitAmountSteps; track unit_amount_step) {
                <div class="deadline" style="left: -14px" [style.bottom]="unit_amount_step.percentage + '%'"></div>
              }
            </div>
          </div>
        </div>
        <div class="bars-names-container">
          @for (bar of bars; track bar) {
            @if (barIsShown(bar)) {
              <div class="bar-name-slot">
                <div class="bar_description">{{ bar.description }}</div>
              </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>
